// eslint-disable-next-line no-restricted-imports
import {useChatState} from '@github-ui/copilot-chat/CopilotChatContext'
import {useChatManager} from '@github-ui/copilot-chat/CopilotChatManagerContext'
import type {CopilotChatMessage} from '@github-ui/copilot-chat/utils/copilot-chat-types'
import {getSelectedThread} from '@github-ui/copilot-chat/utils/get-selected-thread'
import {sendEvent} from '@github-ui/hydro-analytics'
import {XIcon} from '@primer/octicons-react'
import {useCallback} from 'react'

import type {TimelineEventTextReference} from '../../timeline-events/timeline-events-types'

export function useParentMessageRetryCallback() {
  const manager = useChatManager()
  const state = useChatState()

  return useCallback(
    async (message: CopilotChatMessage, customMessage?: string, customInstructions?: string) => {
      let parentMessage: CopilotChatMessage | undefined = undefined
      if (message.parentMessageID) {
        parentMessage = state.messages.findLast(m => m.id === message.parentMessageID && m.id !== 'root')
      }
      if (!parentMessage || !parentMessage.content) return

      sendEvent('dotcom_chat.activate', {
        target: 'BROWSER_ISSUE_RETRY_MESSAGE',
        mode: 'immersive',
        threadId: getSelectedThread(state)?.id,
        customMessage,
      })

      const instructions: TimelineEventTextReference = {
        type: 'text',
        name: `timeline-event: {"type": "automatic-retry", "markdownContent": "${
          customMessage ?? `Copilot failed to generate a response, retrying…`
        }"}`,
        text: customInstructions,
        icon: XIcon,
      }

      await manager.sendChatMessage({
        thread: getSelectedThread(state),
        content: parentMessage.content,
        references: [...(parentMessage.references ?? []), instructions],
        topic: state.currentTopic,
        context: state.context,
        customInstructions: state.customInstructions,
        model: state.model,
        parentMessageId: message.id,
      })
    },
    [manager, state],
  )
}
